import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DirectionsExportContainer, type DirectionsExportContainerProps,
} from './directionsExport.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportDirections: DirectionsExportContainerProps;
  }
}
modalRenderer.register('ExportDirections', DirectionsExportContainer);
